const CSS = () => `
    html.locked,
    html.locked body {
        overflow: hidden;
    }
`;

// function preventTouchMove(e) {
//     e.stopPropagation();
//     e.preventDefault();
// }

function getLenis() {
    return window.lenis || null;
}

function disableScrolling(element) {
    element.classList.add('locked');

    const lenis = getLenis();
    if (lenis) {
        lenis.stop();
    }
}

function enableScrolling(element) {
    element.classList.remove('locked');

    requestAnimationFrame(() => {
        const lenis = getLenis();

        if (lenis) {
            lenis.start();
            lenis.resize();
        }
    });
}

export default class Scrolling {
    constructor() {
        if (!document.documentElement) {
            throw new Error('Document element does not exist');
        }

        this.document = document.documentElement;
        this.head = document.head || document.querySelector('head') || null;

        this.setStyles();
    }

    setStyles() {
        if (!this.head || document.getElementById('site-scrolling-css')) return;

        const style = document.createElement('style');
        style.setAttribute('id', 'site-scrolling-css');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(CSS()));

        this.head.append(style);
    }

    disable() {
        disableScrolling(this.document);
    }

    enable() {
        enableScrolling(this.document);
    }
}